(function (app) {

    var Summary = Backbone.Model.extend({
        defaults: {
            Subtotal: 0,
            Delivery: 0,
            Discount: 0,
            Total: 0,
            Tax: 0,
            Select: 0,
            TotalWithSelect: 0,
            AmountToFreeDelivery: 0,
            applyTax: false,
            DiscountInfo: null
        },

        initialize: function (attrs, opts) {
            _.bindAll(this, '_update');
            this.set('applyTax', GlobalSettings.ApplyTax, { silent: true });
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },

        isDisplayTax: function () {
            return this.get('applyTax');
        },

        _update: function(data) {
            this.set('DiscountInfo', data.DiscountInfo, { silent: true});
            this.set(data.Summary);
        }
    });

    app.models = _.extend({ summary: new Summary() }, app.models);
})(app);